var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgArrowDownIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.678 5.27821C10.9742 5.5744 10.9779 6.05829 10.6817 6.35448L6.35827 10.6779L6.35459 10.6816C6.20698 10.8292 6.01274 10.9024 5.81836 10.9019C5.62393 10.9024 5.42964 10.8293 5.28199 10.6816L5.27832 10.6779L0.954868 6.35448C0.658678 6.05829 0.662351 5.5744 0.958541 5.27821C1.25473 4.98202 1.73862 4.97835 2.03481 5.27454L5.81829 9.05802L9.60177 5.27454C9.89796 4.97835 10.3819 4.98202 10.678 5.27821Z",
    fill: "#4D4D4D"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgArrowDownIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/arrowDownIcon.b31a433c.svg";
export { ForwardRef as ReactComponent };